exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.card--kb h2[data-v-7c24b1d0]{\n    font-size: 15px;\n}\n.card--kb .byline[data-v-7c24b1d0], .card--kb .views[data-v-7c24b1d0]{\n    font-size: 11px;\n    color: #adadad;\n    min-height: auto;\n}\n.card--kb .views[data-v-7c24b1d0]{\n    margin-bottom: 5px;\n}\n.card--kb .views i[data-v-7c24b1d0]{\n    margin-right: 5px;\n}\n", ""]);

// exports
